<div class="grid-container padding-y-4">
    <form [formGroup]="hhgRateQueryForm" class="needs-validation" novalidate>
        <fieldset class="usa-fieldset">
            <legend class="usa-legend usa-legend--large">HHG Queries</legend>
            <div class="usa-alert usa-alert--success usa-alert--slim" *ngIf="message">
                <div class="usa-alert__body">
                    <p class="usa-alert__text">{{ message }}</p>
                </div>
            </div>
            <hr>
            <div class="grid-row grid-gap">
                <div class="grid-col-3">
                    <label for="moveDate" class="usa-label" id="move-date-label">Move Date<abbr title="required"
                                                                                        class="usa-hint usa-hint--required">*</abbr></label>
                  <input type="text" class="usa-input" aria-describedby="move-date-label" id="moveDate" formControlName="pickupDate" [minDate]="minDate" name="moveDate" [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}" bsDatepicker
                         placement="right" placeholder="MM/DD/YYYY" />
                    <div class="text-danger" *ngIf="isFormElementInValid('pickupDate')">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> Please Enter a Valid Move Date
                    </div>

                </div>
                <div class="grid-col-3">
                    <label class="usa-label" for="sroType" id="sro-type-label">Shipment Type<abbr title="required"
                                                                                        class="usa-hint usa-hint--required">*</abbr></label>
                  <select class="usa-select" name="sroType" id="sro" placeholder="SRO Type" formControlName="rateType">
            <option [ngValue]="null">-- Select a Shipment Type --</option>
            <option [ngValue]="sroType" *ngFor="let sroType of sroTypes">{{ sroType }}</option>
          </select>
                    <div class="text-danger" *ngIf="isFormElementInValid('rateType')">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg> Shipment Type is required
                    </div>
                </div>
                <div class="grid-col-3">
                    <label class="usa-label" for="sro" id="sro-label">Shipment ID<abbr title="required"
                                                                             class="usa-hint usa-hint--required">*</abbr></label>
                    <select class="usa-select" name="sroType" id="sroType" placeholder="SRO ID" formControlName="sroMasterId">
            <option [ngValue]="null">--Select a Shipment ID--</option>
            <option [ngValue]="sro.sroMasterId" *ngFor="let sro of sroList">{{ sro.sroId }}</option>
          </select>
                    <div class="text-danger" *ngIf="isFormElementInValid('sroMasterId')">
                        <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                            <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                          </svg>Shipment ID is required
                    </div>
                </div>
                <div class="grid-col-3">
                    <div class="usa-checkbox padding-top-5 define-background-checkbox">
                        <input class="usa-checkbox__input" id="containerised-shipment" type="checkbox" name="containerised-shipment" formControlName="containerizedShipments">
                        <label class="usa-checkbox__label" for="containerised-shipment">Domestic Containerized Shipments</label>
                    </div>
                </div>
            </div>
            <div class="grid-row grid-gap">
                <div class="grid-col-3">
                    <legend class="font-georgia-xl define-margin-top-header">Origin</legend>
                    <div formGroupName="origin">
                        <div class="grid-col">
                            <label for="origin_country" class="usa-label">Country<abbr title="required"
                                                                         class="usa-hint usa-hint--required">*</abbr></label>
                          <select id="origin_country" class="usa-select" formControlName="country" [compareWith]="compareCountryFn">
                <option [ngValue]="null">..Select a Origin Country..</option>
                <option [ngValue]="origCountry"
                        *ngFor="let origCountry of allCountriesObj$ | async">{{ origCountry.stateCountryName }}
                </option>
              </select>
                            <div class="text-danger" *ngIf="isFormElementInValid('origin.country')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                  </svg>Origin Country is required
                            </div>
                        </div>
                        <div *ngIf="this.hhgRateQueryForm.get('origin.usaLocation')" formGroupName="usaLocation">
                            <div class="grid-col">
                                <ng-template #customItemTemplate let-model="item">{{ model.cityName }} , {{ model.stateAbbrev }} {{ model.zipCode }} {{model.zipClassificationCode === 'P' ? 'P.O BOX ONLY' : ''}}
                                </ng-template>
                                <label for="OriginSearchString" class="usa-label">Search Origin: <abbr title="required"
                                                                                       class="usa-hint usa-hint--required">*</abbr></label>
                                <input id="OriginSearchString" role="combobox" class="usa-input" formControlName="searchString" [typeaheadAsync]="true" [typeahead]="dataSourceOriginSearchResults$" typeaheadOptionField="cityName" [typeaheadItemTemplate]="customItemTemplate" (typeaheadOnSelect)="typeaheadOriginOnSelect($event)"
                                    [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100" [typeaheadWaitMs]="1000" [typeaheadScrollable]="true" placeholder="Type a location or zip" />
                            </div>
                            <div class="grid-col">
                                <div class="grid-row">
                                    <div class="grid-col-5">
                                        <label for="origin_city_name" class="usa-label">City</label>
                                        <input type="text" readonly id="origin_city_name" class="usa-input define-padding-location" formControlName="cityName" />
                                    </div>
                                    <div class="grid-col-3">
                                        <label for="origin_state" class="usa-label">State</label>
                                        <input type="text" readonly id="origin_state" class="usa-input define-padding-location" formControlName="state" />
                                    </div>
                                    <div class="grid-col-4">
                                        <label for="origin_zip" class="usa-label">Zip Code</label>
                                        <input type="text" readonly id="origin_zip" class="usa-input define-padding-location" formControlName="zip" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="this.hhgRateQueryForm.get('origin.canadaLocation')" formGroupName="canadaLocation">
                            <div class="grid-col">
                                <label for="origin_Province" class="usa-label">Province</label>
                                <select id="origin_Province" class="usa-select" formControlName="province" [compareWith]="compareCountryFn">
                  <option [ngValue]="null">..Select a Origin Province..</option>
                  <option [ngValue]="province"
                          *ngFor="let province of provincesList$ | async">{{ province.stateCountryName }}
                  </option>
                </select>
                                <div class="text-danger" *ngIf="
                      isFormElementInValid('origin.canadaLocation.province')
                    ">
                                    <span class="fa fa-warning"></span>Origin Province is required
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="this.hhgRateQueryForm.get('destination')" class="grid-col-3">
                    <legend class="font-georgia-xl define-margin-top-header">Destination</legend>
                    <div formGroupName="destination">
                        <div class="grid-col">
                            <label for="destination_country" class="usa-label">Country<abbr title="required"
                                                                              class="usa-hint usa-hint--required">*</abbr></label>
                          <select id="destination_country"  class="usa-select" formControlName="country" [compareWith]="compareCountryFn">
                <option [ngValue]="null">..Select a Destination Country..</option>
                <option [ngValue]="country"
                        *ngFor="let country of allCountriesObj$ | async">{{ country.stateCountryName }}
                </option>
              </select>
                            <div class="text-danger" *ngIf="isFormElementInValid('destination.country')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                  </svg>Destination Country is required
                            </div>
                        </div>

                        <div *ngIf="this.hhgRateQueryForm.get('destination.usaLocation')" formGroupName="usaLocation">
                            <div class="grid-col">
                                <ng-template #customItemTemplate let-model="item">{{ model.cityName }} , {{ model.stateAbbrev }} {{ model.zipCode }} {{model.zipClassificationCode === 'P' ? 'P.O BOX ONLY' : ''}}
                                </ng-template>
                                <label for="DestinationSearchString" class="usa-label">Search Destination:<abbr title="required"
                                                                                                class="usa-hint usa-hint--required">*</abbr>
                </label>
                                <input id="DestinationSearchString" role="combobox" class="usa-input" formControlName="searchString" [typeaheadAsync]="true" [typeahead]="dataSourceDestinationSearchResults$" typeaheadOptionField="cityName" [typeaheadItemTemplate]="customItemTemplate" (typeaheadOnSelect)="typeaheadDestinationOnSelect($event)"
                                    [typeaheadOptionsInScrollableView]="10" [typeaheadOptionsLimit]="100" [typeaheadWaitMs]="1000" [typeaheadScrollable]="true" placeholder="Type a location or zip" />
                            </div>
                            <div class="grid-col">
                                <div class="grid-row">
                                    <div class="grid-col-5">
                                        <label for="destination_city_name" class="usa-label">City</label>
                                        <input type="text" readonly id="destination_city_name" class="usa-input define-padding-location" formControlName="cityName" />
                                    </div>
                                    <div class="grid-col-3">
                                        <label for="destination_state" class="usa-label">State</label>
                                        <input type="text" readonly id="destination_state" class="usa-input define-padding-location" formControlName="state" />
                                    </div>
                                    <div class="grid-col-4">
                                        <label for="destinationZip" class="usa-label">Zip Code</label>
                                        <input type="text" readonly id="destinationZip" class="usa-input define-padding-location" formControlName="zip" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="this.hhgRateQueryForm.get('destination.canadaLocation')" formGroupName="canadaLocation">
                            <div class="grid-col">
                                <label for="dest_Province" class="usa-label">Province</label>
                                <select id="dest_Province" class="usa-select" formControlName="province" [compareWith]="compareCountryFn">
                  <option [ngValue]="null">..Select a Destination Province..</option>
                  <option [ngValue]="province"
                          *ngFor="let province of provincesList$ | async">{{ province.stateCountryName }}
                  </option>
                </select>
                                <div class="text-danger" *ngIf="isFormElementInValid('destination.canadaLocation.province')">
                                    <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                        <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                      </svg>Destination Province is required
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid-col-3">
                    <legend class="font-georgia-xl define-margin-top-header">Shipment Information</legend>
                    <div class="grid-col" *ngIf="this.hhgRateQueryForm.get('miles')">
                        <label for="mileage" class="usa-label">Estimated Mileage<abbr title="required"
                                class="usa-hint usa-hint--required">*</abbr></label>
                        <input type="text" id="mileage" class="usa-input" formControlName="miles" min="1" max="99999" />
                        <div *ngIf="isFormElementInValid('miles')">
                            <div class="text-danger" *ngIf="this.hhgRateQueryForm.get('miles').hasError('required')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                  </svg>Please enter the estimated mileage
                            </div>
                            <div class="text-danger" *ngIf="this.hhgRateQueryForm.get('miles').hasError('numeric')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                  </svg> Estimated Mileage must be numeric
                            </div>
                            <div class="text-danger" *ngIf="this.hhgRateQueryForm.get('miles').hasError('max')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                  </svg>Estimated Mileage must be maximum 99999
                            </div>
                            <div class="text-danger" *ngIf="this.hhgRateQueryForm.get('miles').hasError('min')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                  </svg> Estimated Mileage must be minimum 1
                            </div>
                        </div>
                        <small *ngIf="estimatedMileageWarning" class="define-text-warning">{{estimatedMileageWarningMessage}}</small>
                    </div>
                    <div class="grid-col">
                        <label for="weight" class="usa-label">Estimated Weight (lbs)<abbr title="required" class="usa-hint usa-hint--required">*</abbr></label>
                        <input type="text" id="weight" class="usa-input" maxlength="8" formControlName="estimatedWeight"/>
                        <div *ngIf="isFormElementInValid('estimatedWeight')">
                            <div class="text-danger" *ngIf="this.hhgRateQueryForm.get('estimatedWeight').hasError('required')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                  </svg> Estimated Weight is required
                            </div>
                            <div class="text-danger" *ngIf="this.hhgRateQueryForm.get('estimatedWeight').hasError('numeric')
                                                                && this.hhgRateQueryForm.get('estimatedWeight').hasError('pattern')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                  </svg> Estimated Weight must be numeric whole numbers
                            </div>
                            <div class="text-danger" *ngIf="this.hhgRateQueryForm.get('estimatedWeight').hasError('min')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                  </svg> Estimated Weight must be minimum 1,000 lbs
                            </div>
                            <div class="text-danger" *ngIf="this.hhgRateQueryForm.get('estimatedWeight').hasError('maxlength')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                  </svg> Estimated Weight must be maximum 99999999 lbs
                            </div>
                        </div>
                    </div>
                    <div class="grid-col" *ngIf="this.hhgRateQueryForm.get('vehicleClass')">
                        <label for="vehicle" class="usa-label">Vehicle</label>
                        <select id="vehicle" class="usa-select" formControlName="vehicleClass">
                            <option [ngValue]="null">-- Select a Vehicle --</option>
                            <option [ngValue]="vehicle.name" *ngFor="let vehicle of vehicles">{{ vehicle.description }}</option>
                        </select>
                        <div class="text-danger" *ngIf="isFormElementInValid('vehicleClass')">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                              </svg> Vehicle is required
                        </div>
                    </div>
                    <div class="grid-col" *ngIf="this.hhgRateQueryForm.get('uabWeight')">
                        <label for="uab" class="usa-label">Estimated UAB (lbs)</label>
                        <input type="numeric" id="uab" class="usa-input"  formControlName="uabWeight" />
                        <div *ngIf="isFormElementInValid('uabWeight')">
                            <div class="text-danger" *ngIf="this.hhgRateQueryForm.get('uabWeight').hasError('required')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                  </svg>Estimated UAB Weight is required
                            </div>
                            <div class="text-danger" *ngIf="this.hhgRateQueryForm.get('uabWeight').hasError('maxlength')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                  </svg> Estimated UAB Weight must be maximum 99999999 lbs
                            </div>
                            <div class="text-danger" *ngIf="this.hhgRateQueryForm.get('uabWeight').hasError('numeric')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                  </svg> Estimated UAB Weight must be numeric
                            </div>
                            <div class="text-danger" *ngIf="this.hhgRateQueryForm.get('uabWeight').hasError('min')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                  </svg>UAB must be minimum 100lbs
                            </div>
                        </div>
                        <small class="define-text-warning">UAB weight is accepted in pounds. Please convert kg to lb before entering weight</small>
                    </div>
                </div>
                <div class="grid-col-3"
                    *ngIf="this.hhgRateQueryForm.get('noOfDays') || this.hhgRateQueryForm.get('sitBreakdown') || this.hhgRateQueryForm.get('sit')">
                    <legend class="font-georgia-xl define-margin-top-header">Storage In Transit Information</legend>
                    <div class="grid-col" *ngIf="this.hhgRateQueryForm.get('sit')">
                        <label for="sit" class="usa-label">SIT</label>
                        <select id="sit" formControlName="sit" class="usa-select" placeholder="SIT">
                            <option [ngValue]="sit" *ngFor="let sit of sitValues">{{ sit }}</option>
                        </select>
                    </div>
                    <div class="grid-col" *ngIf="this.hhgRateQueryForm.get('sitBreakdown')">
                        <label for="sit_breakdown" class="usa-label">SIT Breakdown</label>
                        <select id="sit_breakdown" formControlName="sitBreakdown" class="usa-select" placeholder="SIT Breakdown"
                            (change)="onBreakdownChange()">
                            <option [ngValue]="sitBreakdown" *ngFor="let sitBreakdown of sitBreakdownValues">{{ sitBreakdown }}</option>
                        </select>
                    </div>
                    <div class="grid-col" *ngIf="this.hhgRateQueryForm.get('noOfDays')">
                        <label for="days" class="usa-label">No. of Days</label>
                        <input type="text" id="days" class="usa-input" appNumbersOnly formControlName="noOfDays" maxlength="5"
                            placeholder="No. of days" />
                            <div class="text-danger" *ngIf="this.hhgRateQueryForm.get('noOfDays').hasError('pattern')">
                                <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                    <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                                  </svg> No. of Days must be numeric whole numbers
                            </div>
                    </div>
                </div>
            </div>
            <hr>
            <div class="grid-row">
                <legend class="font-georgia-xl define-margin-top-header">Employee Information</legend>
            </div>
            <div class="grid-row grid-gap">
                <div class="grid-col-4">
                    <label for="first_name" class="usa-label">First Name</label>
                    <input type="text" id="first_name" class="usa-input" formControlName="employeeFirstName" placeholder="Employee First Name" />
                    <div *ngIf="isFormElementInValid('employeeFirstName')">
                        <div class="text-danger" *ngIf="this.hhgRateQueryForm.get('employeeFirstName').hasError('maxlength')">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                              </svg>Employee First Name must be maximum 45 characters
                        </div>
                    </div>
                </div>
                <div class="grid-col-4">
                    <label for="middle_name" class="usa-label">Middle Initial</label>
                    <input type="text" id="middle_name" class="usa-input" formControlName="employeeMiddleName" placeholder="Employee Middle Name" />
                    <div *ngIf="isFormElementInValid('employeeMiddleName')">
                        <div class="text-danger" *ngIf="this.hhgRateQueryForm.get('employeeMiddleName').hasError('maxlength')">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                              </svg>Employee Middle Initial must be 1 character
                        </div>
                    </div>
                </div>
                <div class="grid-col-4">
                    <label for="last_name" class="usa-label">Last Name</label>
                    <input type="text" id="last_name" class="usa-input" formControlName="employeeLastName" placeholder="Employee Last Name" />
                    <div *ngIf="isFormElementInValid('employeeLastName')">
                        <div class="text-danger" *ngIf="this.hhgRateQueryForm.get('employeeLastName').hasError('maxlength')">
                            <svg class="usa-icon" aria-hidden="true" focusable="false" role="img">
                                <use xlink:href="/assets/uswds/img/sprite.svg#warning"></use>
                              </svg>Employee Last Name must be maximum 45 characters
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-row padding-top-4">
                <button class="usa-button " (click)="hhgQuery()" [disabled]="hhgRateQueryForm.invalid">Query</button>
                <button class="usa-button usa-button--outline" (click)="resetForm()">Reset</button>
            </div>
        </fieldset>
    </form>
    <div class="grid-row" [hidden]="!showResults">
            <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
                <app-hhg-rate-query-results
                    [hhgRateQueryResults]="hhgRateQueryResults$ | async"
                    [moveDate]="this.hhgRateQueryForm.get('pickupDate').value"
                    [showComments]="showComments"
                    [extendedStorage]="extendedStorage"
                    [sroType]="this.hhgRateQueryForm.get('rateType') ? this.hhgRateQueryForm.get('rateType').value : null"
                    (hhgRateQuerySelected)="onhhgRateQuerySelected($event)"
                    [vehicleClass]="this.hhgRateQueryForm.get('vehicleClass') ? this.hhgRateQueryForm.get('vehicleClass').value : null"
                    [sit]="this.hhgRateQueryForm.get('sit') ? this.hhgRateQueryForm.get('sit').value : null"
                    [isInternational]="isInternational ? isInternational : null"
                    [uabWeight]="this.hhgRateQueryForm.get('uabWeight') ? this.hhgRateQueryForm.get('uabWeight').value : null"
                    [isShownUAB]="isShownUAB"
                    [pickUpDate]="effectiveExpDateObj$ | async"
                    [sitBreakdown]="this.hhgRateQueryForm.get('sitBreakdown') ? this.hhgRateQueryForm.get('sitBreakdown').value : null"
                    [noOfDays]="this.hhgRateQueryForm.get('noOfDays') ? this.hhgRateQueryForm.get('noOfDays').value : null"
                    [excelHeaderString]="excelHeaderString"
                    [userPrefList]="this.userPrefList"
                    [screenName]="this.screenName">
                </app-hhg-rate-query-results>
            </div>

    </div>
  </div>
